import React from "react";
import { makeStyles, CircularProgress, Modal } from "@material-ui/core";

interface Props {
  isShown: boolean;
}

export default function TrSpinner({ isShown }: Props) {
  const classes = useStyles({});

  return (
    <Modal
      open={isShown}
      disableBackdropClick
      hideBackdrop
      disableAutoFocus
      disableEnforceFocus
    >
      <div className={classes.overlay}>
        <div className={classes.spinnerContainer}>
          <CircularProgress size={50} />
        </div>
      </div>
    </Modal>
  );
}

const useStyles = makeStyles((theme) => ({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    zIndex: 1300,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  spinnerContainer: {
    position: "relative",
  },
}));
